import { FAQSection, LearnSection } from '../content/learn';
import { MediaCarousel } from '../content/mediaCarousel';
import { MetaTags } from '../content/metaTags';
import { NDAOTokenCallout } from '../content/ndaoTokenCallout';
// import { NDAOTokenCallout } from '../content/ndaoTokenCallout';
import { SocialLinks } from '../content/socialLinks';

const LearnPage = () => {
  return (
    <>
      <MetaTags url="/learn" title="Endaoment | Learn" />

      <LearnSection />
      <FAQSection />
      <NDAOTokenCallout />
      <MediaCarousel />
      <SocialLinks />
    </>
  );
};

export default LearnPage;
